// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Appointments-module__button___IaK5z {
  height: 38px;
  margin: 16px 0 0 16px;
  width: auto;
  align-self: start;
}

.Appointments-module__title___UsZ1s {
  color: #375844;
  display: block;
  margin: 16px 0 24px 16px;
  font-size: 1.25rem;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientDetails/fragments/Appointments/Appointments.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;AACF","sourcesContent":[".button {\n  height: 38px;\n  margin: 16px 0 0 16px;\n  width: auto;\n  align-self: start;\n}\n\n.title {\n  color: #375844;\n  display: block;\n  margin: 16px 0 24px 16px;\n  font-size: 1.25rem;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Appointments-module__button___IaK5z`,
	"title": `Appointments-module__title___UsZ1s`
};
module.exports = ___CSS_LOADER_EXPORT___;
